import { ModalContent, ModalFooter } from '@components/modal';

type HelpRequestCloseModalProps = {
  onClose: (helpInquiryId: number) => void;
  helpInquiryId: number;
};

const HelpRequestCloseModal = ({ onClose, helpInquiryId }: HelpRequestCloseModalProps) => (
  <ModalContent title='Confirm Complete Help Inquiry'>
    <section className='modal-body'>
      <div>
        <p>Are you sure you want to complete this help inquiry?</p>
      </div>
    </section>
    <ModalFooter onSave={() => onClose(helpInquiryId)} saveText='Yes' cancelText='No' showCancelButton />
  </ModalContent>
);

export default HelpRequestCloseModal;
